const InfoBox = ({ data }) => {
  return (
    <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
      {data.map((box, index) => (
        <div
          key={index}
          className={`absolute text-white backdrop-blur-md p-4 rounded-lg text-sm flex items-center 
            ${box.classes.desktop} ${box.classes.tablet} ${box.classes.mobile}`}
        >
          <img
            src={box.icon.src}
            alt={box.icon.alt}
            className="w-11 sm:w-12 md:w-14 2xl:w-28 mr-4"
          />
          <div>
            <h3 className="font-bold text-[12px] sm:text-sm md:text-base 2xl:text-3xl">
              {box.heading}
            </h3>
            <p className="mt-1 break-words text-[10px]/tight sm:text-xs md:text-sm 2xl:text-xl">
              {box.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default InfoBox;
